import { useRef } from "react";
import type { Avatar } from "primereact/avatar";

import { useUserPhoto } from "@/hooks";
import { useInView } from "./hooks/use-in-view";
import type {
  UserAvatarByEmailProps,
  UserAvatarByEmailViewModel,
} from "./types-user-avatar-by-email";
import { getUserPhotoPathByEmail } from "@/shared/utils/user-photo";

/** ViewModel do `UserAvatarByEmail`: busca a foto pelo e-mail só com o avatar na viewport; sem JSX. */
export function useUserAvatarByEmail({
  email,
  fotoUrl,
  enabled = true,
  ...avatarProps
}: UserAvatarByEmailProps): UserAvatarByEmailViewModel {
  const avatarRef = useRef<Avatar>(null);
  const inView = useInView(avatarRef);
  const path = fotoUrl ? null : getUserPhotoPathByEmail(email);
  const fetched = useUserPhoto(path, enabled && inView);

  return { ...avatarProps, avatarRef, fotoSrc: fotoUrl || fetched };
}
